<template>
  <div class="registration" style="padding-top: 60px;">
    <div class="content">
      <!-- 替换为选择器 -->
      <a-form-item label="赛事类型" required>
        <a-select
          v-model="selectedCompetitionType"
          placeholder="请选择赛事类型"
          :disabled="readonly"
          style="width: 200px; margin-bottom: 20px"
          @change="handleNext"
        >
          <a-select-option value="1">综合赛</a-select-option>
          <a-select-option value="2">企业命题赛</a-select-option>
        </a-select>
      </a-form-item>
      <div v-if="!hasAward" class="tip">
        <font color="ED1C24">
          {{ $t('user-comphonents-add/csign-up') }}
        </font>
      </div>
    </div>
  </div>
</template>
<script>
import { checkAward } from '@/api/product'
import request from '@/utils/request'
import zh from '@/lang/zh.json'
import en from '@/lang/en.json'
import { getLKey } from '@/utils/auth'

const i18n = { zh, en }
const lang = getLKey()

export default {
  props: {
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      hasAward: true,
      request: request,
      selectedCompetitionType: '' // 新增选中值变量
    }
  },
  computed: {
    // 新增：获取当前赛事类型
    currentCompetitionType() {
      return this.$store.state.global.currentCompetitionType
    }
  },
  watch: {
    currentCompetitionType(newVal) {
      console.log('currentCompetitionType', newVal)
      this.selectedCompetitionType = newVal
    },
    readonly(newVal) {
      // 当readonly状态改变时，确保显示正确的赛事类型
      if (newVal && this.currentCompetitionType) {
        this.selectedCompetitionType = this.currentCompetitionType
      }
    }
  },
  created() {
    if (this.currentCompetitionType) {
      this.selectedCompetitionType = this.currentCompetitionType
    }
    checkAward().then(res => {
      this.hasAward = !!res.status
    }).catch(res => {
      console.error(res)
    })
    this.selectedCompetitionType = '1'
    this.handleNext(true) // 传入true表示是初始化调用
  },
  methods: {
    handleNext(isInitialization = false) {
      console.log('[DEBUG][add] handleNext called, isInitialization:', isInitialization, 'readonly:', this.readonly)
      if (this.readonly) {
        console.log('[DEBUG][add] Readonly mode, returning')
        return // 在只读状态下不执行任何操作
      }
      if (!this.selectedCompetitionType) {
        this.$message.warning('请选择赛事类型')
        return
      }
      if (this.hasAward) {
        // 只有在非初始化情况下才通知父组件用户主动修改了竞赛类型
        // 使用严格比较，确保只有真正的初始化调用才不发出事件
        if (isInitialization !== true && isInitialization !== 1) {
          console.log('[DEBUG][add] Emitting userChangedCompetitionType event')
          this.$emit('userChangedCompetitionType')
        } else {
          console.log('[DEBUG][add] Initialization mode, not emitting userChangedCompetitionType event')
        }
        console.log('[DEBUG][add] Setting competition type to:', this.selectedCompetitionType)
        this.$store.commit('global/SET_CURRENT_COMPETITION_TYPE', this.selectedCompetitionType)
        // 清空类别选择
        this.$store.commit('global/SET_COMPETITION_CATEGORY', '')
        this.$store.dispatch('global/getDistricts').then(() => {
          this.$emit('next', this.selectedCompetitionType)
        })
      } else {
        this.$message.error({ content: i18n[lang]['user-comphonents-add/unadd-product'], key: 'message', duration: 4 })
      }
    }
  }
}
</script>
<style lang="less" scoped>
.registration {
  text-align: center;
}

// .content {
//   width: 30.85%;
//   width: 60%;
//   background:rgba(255,255,255,1);
//   box-shadow:-1px 8px 48px 9px rgba(24,24,24,0.09);
//   border-radius:10px;
//   margin: 7.83% auto 0;
//   padding-top: 5.41%;
// }

.content {
  width: 100%;
  margin-top: -50px;
  text-align: left;
  .btn1,
  .btn2 {
    width: 200px;
    height: 80px;
    font-size: 20px;
  }

  .btn2 {
    margin-left: 80px;
    background: #ff9933;
    border: 1px solid #ff9933;
  }
}

.circle {
  width: 43.5%;
  /* height: 43.5%;
    line-height: 100%; */
  font-size: 21.11%;
  color: #006ae1;
  background: rgba(248, 248, 248, 1);
  border-radius: 50%;
  border: 2px dashed #006ae1;
  margin: 0 auto 12.03%;
  clear: both;
  cursor: pointer;
}

.circle::before {
  content: '+';
  padding: 48% 0 52%;
  display: block;
  line-height: 0;
  font-size: 62px;
}

.button button {
  height: 45px;
  line-height: 45px;
  font-size: 20px;
  margin-bottom: 10px;
}

.tip {
  font-size: 16px;
}

.tip2 {
  margin-top: 57px;
  font-size: 20px;
}

.tip2 a {
  text-decoration: underline;
  color: #ed1c24;
}
</style>
